import Cookies from 'universal-cookie';

const ck = new Cookies(null, { path: '/' });

const CookieService = {
  set(name: string, value: any, options = { path: '/' }): void {
    ck.set(name, value, options);
    return;
  },

  get(name: string): string | undefined {
    return ck.get(name);
  },

  delete(name: string): void {
    ck.remove(name, { path: '/' });
    return;
  },

  check(name: string): boolean {
    return !!ck.get(name);
  },
};

export default CookieService;
